<template>
  <div>
    <van-nav-bar title="请假申请" left-text="返回" right-text="" @click-left="onClickLeft"/>
    <!--    <van-tabs  color="#2196f3" style="margin-top: 10px;" @click="parentRuleClick">-->
    <!--      <van-tab v-for="item in parentRuleList" :title="item.name" :name="item.id"></van-tab>-->
    <!--    </van-tabs>-->
    <!--    <van-tabs  color="#2196f3" style="margin-top: 10px;" @click="childRuleClick">-->
    <!--      <van-tab v-for="item in childRuleList" :title="item.name" :name="item.id"></van-tab>-->
    <!--    </van-tabs>-->
    <!--    <van-notice-bar-->
    <!--      wrapable-->
    <!--      :scrollable="false"-->
    <!--      :text="ruleRemark"-->
    <!--    />-->
    <van-collapse v-model="activeNames">
      <van-collapse-item title="请假规则说明" name="1" icon="calendar-o">
        <div style="color: red" v-html="this.ruleRemark"></div>
      </van-collapse-item>
    </van-collapse>
    <van-form class="login-form-top">
      <van-field
        readonly
        clickable
        name="parentRule"
        :value="parentRuleName"
        label="请假类型"
        placeholder="点击选择请假类型"
        @click="parentRuleShow = true"
        :rules="[{ required: true, message: '请选择请假类型' }]"
      />
      <van-action-sheet v-model="parentRuleShow" :actions="parentRuleList" @select="parentRuleClick"/>
      <van-field
        readonly
        clickable
        name="childRule"
        :value="childRuleName"
        label="请假子类型"
        placeholder="点击选择请假子类型"
        @click="childRuleShow = true"
        :rules="[{ required: true, message: '请选择请假子类型' }]"
      />
      <van-action-sheet v-model="childRuleShow" :actions="childRuleList" @select="childRuleClick"/>

      <van-field
        readonly
        clickable
        name="effectiveDate"
        :value="effectiveDate"
        label="父母出生日期"
        placeholder="点击选择日期"
        :rules="[{ required: true, message: '请选择父母出生日期' }]"
        @click="showEffectiveCalendar = true"
        v-if="effectiveDays == 21900"
      />
      <van-field
        readonly
        clickable
        name="effectiveDate"
        :value="effectiveDate"
        label="孩子出生日期"
        placeholder="点击选择日期"
        :rules="[{ required: true, message: '请选择孩子出生日期' }]"
        @click="showEffectiveCalendar = true"
        v-if="effectiveDays == 1095"
      />
      <van-field
        readonly
        clickable
        name="effectiveDate"
        :value="effectiveDate"
        label="领证日期"
        placeholder="点击选择日期"
        :rules="[{ required: true, message: '请选择领证日期' }]"
        @click="showEffectiveCalendar = true"
        v-if="effectiveDays == 365"
      />
      <van-calendar :show-confirm="false" v-model="showEffectiveCalendar" @confirm="onEffectiveDateConfirm"
                    :min-date="minOtherDate" :max-date="maxDate"/>

      <van-field
        readonly
        v-model="effectiveDays"
        name="effectiveDays"
        label="请假有效天数"
        placeholder="请假天数"
        v-if="effectiveDays > -1"
        :rules="[{ 请假有效天数: true, message: '请填写请假有效天数' }]"
      />

      <van-field
        readonly
        clickable
        name="beginTime"
        :value="beginTime"
        label="开始时间"
        placeholder="点击选择日期"
        :rules="[{ required: true, message: '请选择开始时间' }]"
        @click="showBeginCalendar = true"
      />
      <van-calendar :show-confirm="false" v-model="showBeginCalendar" @confirm="onBeginConfirm"
                    :min-date="minDate" :max-date="maxDate"/>
      <van-field
        readonly
        clickable
        name="endTime"
        :value="endTime"
        label="结束时间"
        placeholder="点击选择日期"
        :rules="[{ required: true, message: '请选择结束时间' }]"
        @click="showEndCalendar = showCalendarStatus"
      />
      <van-calendar :show-confirm="false" v-model="showEndCalendar" @confirm="onEndConfirm"
                    :min-date="minDate" :max-date="maxDate"/>
      <van-field name="radio" label="时间段" v-if="isHalfShow && minDays < 1">
        <template slot="input">
          <van-radio-group v-model="dayHalf" direction="horizontal" @change="halfChange()">
            <van-radio :name="item.dictKey" v-for="item in dayHalfList" :key="item.dictKey">
              {{ item.dictValue }}
            </van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field
        readonly
        v-model="leaveTotalDays"
        name="leaveTotalDays"
        label="本年已请天数"
        placeholder="本年已请天数"
        :rules="[{ required: true, message: '请填写本年已请天数' }]"
      />
      <van-field
        readonly
        v-if="dayNum < 365"
        v-model="surplusDays"
        name="surplusDays"
        label="本年剩余天数"
        placeholder="本年剩余天数"
        :rules="[{ required: true, message: '请填写本年剩余天数' }]"
      />
      <van-field
        readonly
        v-model="day"
        name="day"
        label="请假天数"
        placeholder="请假天数"
        :rules="[{ required: true, message: '请填写请假天数' }]"
      />
      <van-field
        v-if="isTraffic == 1"
        readonly
        clickable
        :value="trafficDayName"
        name="trafficDay"
        label="路程天数"
        placeholder="点击选择路程天数"
        @click="showPicker = true"
        :rules="[{ required: true, message: '请选择路程天数' }]"
      />
      <van-action-sheet v-model="showPicker" :actions="trafficDayList" @select="trafficDaySelect" v-if="isTraffic == 1"/>

      <van-field
        v-model="destination"
        v-if="isTraffic == 1"
        name="destination"
        label="目的地"
        placeholder="目的地"
        :rules="[{ required: true, message: '请填写目的地' }]"
      />

      <van-field
        v-model="reason"
        rows="3"
        autosize
        label="请假原因"
        type="textarea"
        maxlength="50"
        placeholder="请填写请假原因"
        show-word-limit
      />
      <van-field name="applyFile" label="附件">
        <template slot="input">
          <van-uploader :before-read="beforeApplyFileRead" :after-read="afterApplyFileRead"
                        :max-size="5000 * 1024" max-count="6" v-model="showFiles" multiple
                        :before-delete="beforeApplyFileDelete"
                        accept="image/*,.pdf,.doc,.docx,.xml,.dwg,.ppt,.pptx,.txt,.xls,.xlsx,.zip,.rar">
          </van-uploader>
        </template>
      </van-field>

    </van-form>
<!--    <div style="margin: 16px;">-->
<!--      <van-button round block type="primary" native-type="submit" @click="taskSave">保存</van-button>-->
<!--    </div>-->
    <div style="margin: 16px;">
      <van-button round block type="info" native-type="submit" @click="taskSubmit">提交</van-button>
    </div>

    <van-dialog v-model="roleShow" title="我的角色" show-cancel-button @confirm="roleCommit" confirmButtonText="提交">
      <van-radio-group v-model="roleRadio">
        <van-cell-group>
          <van-cell :title="item.roleName" clickable v-for="item in roleList" :key="item.id"
                    clickable @click="roleRadio = item.id">
            <template slot="right-icon">
              <van-radio :name="item.id"></van-radio>
            </template>
          </van-cell>
        </van-cell-group>
      </van-radio-group>
    </van-dialog>
    <ProcessDialog ref="showProcessDialog" :submitFlowMethod="submitFlowMethod" :getFlowParamsMethod="getFlowParamsMethod"/>
  </div>
</template>

<script>

import {Dialog, Toast} from "vant";
import Vue from "vue";
import moment from "moment";
import {isLogin, isWechat, replaceUrl} from "../../../utils/util";

export default {
  name: "HolidayApply",
  data() {
    return {
      trafficDayName: '',
      trafficDayList: [],
      showPicker: false,
      makeSureShow: false,
      activeNames: ['1'],
      modelKey: "Leave",
      taskId: '',
      processInstanceId: '',
      processDefinitionId: '',
      appNo: '',
      parentRuleList: [],
      parentRule: 0,
      parentRuleName: '',
      parentRuleShow: false,
      childRuleList: [],
      childRule: 0,
      childRuleName: '',
      childRuleShow: false,
      showBeginCalendar: false,
      beginTime: '',
      showEndCalendar: false,
      endTime: '',
      leaveTotalDays: 0,
      surplusDays: 0,
      day: 0,
      dayHalf: 0,
      isHalfShow: false,
      dayHalfList: [],
      realName: '',
      deptName: '',
      userInfo: {},
      leaveId: 0,
      dayNum: 0,
      minDays: 0,
      isTraffic: 0,
      isWeekend: 0,
      isHoliday: 0,
      isOutYear: 1,
      effectiveDays: -1,
      effectiveDate: '',
      showEffectiveCalendar: false,
      onceDays: 0,
      choseRoleId: '',
      nextProcess: false,
      minOtherDate: new Date(1950, 0, 1),
      minDate: new Date(2010, 0, 1),
      maxDate: new Date(2099, 0, 31),
      trafficDay: 0,
      destination: '',
      reason: '',
      showFiles: [],
      allFiles: {
        applyFiles: [],
        removedFiles: [],
      },
      applyFileIds: [],
      workYear: 0,
      ruleRemark: '',
      roleShow: false,
      roleRadio: 0,
      roleList: [],
      pageType: 0,
      processShow: false,
      showCalendarStatus: true,
      isUploadFile: 0,
    };
  },
  mounted() {
    if(!isLogin()){
      this.$router.push({
        path: "/attenceflow/Error",
        query: {
        }
      });
    }

    this.appNo = this.$route.query.appNo;
    this.processInstanceId = this.$route.query.processInstanceId;
    this.taskId = this.$route.query.taskId;
    this.processDefinitionId = this.$route.query.processDefinitionId;
    this.leaveId = this.$route.query.leaveId;
    this.pageType = this.$route.query.pageType;
    this.initUserInfo();
  },
  methods: {
    trafficDaySelect(item) {
      this.showPicker = false;
      this.trafficDay = item.value;
      this.trafficDayName = item.name;
      if (this.beginTime != '') {
        if (this.effectiveDate == null) {
          this.effectiveDate = '';
        }
        this.$fetch("/attence-api/blade-holiday-leave/holidayleave/getLeaveDays", {
          beginTime: this.beginTime,
          endTime: '',
          isWeekend: this.isWeekend,
          isHoliday: this.isHoliday,
          isTraffic: this.isTraffic,
          trafficDay: this.trafficDay,
          ruleId: this.parentRule,
          childRuleId: this.childRule,
          effectiveDate: this.effectiveDate,
        }).then(res => {
          const data = res.data;
          this.isHalfShow = false;
          this.day = data.days;
          this.endTime = data.endTime;
        });
      } else {
        this.isHalfShow = false;
        this.day = 0;
      }
    },
    initUserInfo() {
      this.getUserInfo();
    },
    getUserInfo() {
      this.$fetch("/attence-api/blade-user/info", {}).then(
        res => {
          const user = res.data;
          this.realName = user.realName;
          this.deptName = user.deptName;
          this.userInfo = user;
          this.workYear = user.workYear;
          this.initHolidayRule();
        }
      );
      this.$fetch("/attence-api/blade-system/dict-biz/dictionary-tree", {
        code: 'traffic_day'
      }).then(res => {
        const data = res.data;
        data.map(item => {
          const obj = {
            value: +item.dictKey,
            name: item.dictValue
          };
          this.trafficDayList.push(obj);
        });
      });
    },
    getMyLeaveDaysAndShow() {
      const params = {
        ruleId: this.parentRule,
        childRuleId: this.childRule,
      };
      this.$fetch("/attence-api/blade-holiday-leave/holidayleave/getMyLeaveDays", params).then(
        res => {
          const data = res.data;
          this.leaveTotalDays = data.leaveTotalDays;
          this.surplusDays = data.surplusDays;
          this.effectiveDate = data.effectiveDate;
        }
      );
    },
    beginLeaveDateChange() {
      if (this.beginTime != '') {
        if (this.effectiveDate == null) {
          this.effectiveDate = '';
        }
        this.$fetch("/attence-api/blade-holiday-leave/holidayleave/getLeaveDays", {
          beginTime: this.beginTime,
          endTime: '',
          isWeekend: this.isWeekend,
          isHoliday: this.isHoliday,
          isTraffic: this.isTraffic,
          trafficDay: this.trafficDay,
          ruleId: this.parentRule,
          childRuleId: this.childRule,
          effectiveDate: this.effectiveDate,
        }).then(res => {
          const data = res.data;
          this.isHalfShow = false;
          this.day = data.days;
          this.endTime = data.endTime;
        });
      } else {
        this.isHalfShow = false;
        this.day = 0;
      }
    },
    leaveDateChange() {
      if (this.beginTime != '' && this.endTime != '') {
        if (this.effectiveDate == null) {
          this.effectiveDate = '';
        }
        this.$fetch("/attence-api/blade-holiday-leave/holidayleave/getLeaveDays", {
          beginTime: this.beginTime,
          endTime: this.endTime,
          isWeekend: this.isWeekend,
          isHoliday: this.isHoliday,
          isTraffic: this.isTraffic,
          trafficDay: this.trafficDay,
          ruleId: this.parentRule,
          childRuleId: this.childRule,
          effectiveDate: this.effectiveDate,
        }).then(res => {
          const data = res.data;
          let days = data.days;
          let hasApplyHalfDay = data.hasApplyHalfDay;
          //this.leaveTotalDays = data.leaveTotalDays;
          //this.surplusDays = data.leaveTotalDays;
          if (days <= 1) {
            this.isHalfShow = true;
            const _this = this;
            this.dayHalfList = [];
            this.$fetch("/attence-api/blade-system/dict-biz/dictionary-tree", {
              code: 'halfday'
            }).then(res => {
              const dicData = res.data;
              if (_this.onceDays == 0.5) {
                dicData.forEach(function (column) {
                  if (hasApplyHalfDay == 0) {
                    if (column.dictKey != 0) {
                      _this.dayHalfList.push(column);
                    }
                  } else {
                    if (column.dictKey != 0 && column.dictKey != hasApplyHalfDay) {
                      _this.dayHalfList.push(column);
                    }
                  }
                });
                this.day = days;
              } else {
                dicData.forEach(function (column) {
                  if (hasApplyHalfDay == 0) {
                    _this.dayHalfList.push(column);
                  } else {
                    if (column.dictKey != 0 && column.dictKey != hasApplyHalfDay) {
                      _this.dayHalfList.push(column);
                    }
                  }
                });
                if (hasApplyHalfDay == 0) {
                  this.day = 1;
                } else {
                  this.day = 0.5;
                }
              }
              this.dayHalf = this.dayHalfList[0].dictKey;
            });
          } else {
            this.isHalfShow = false;
            this.day = days;
          }

        }, error => {
          this.beginTime = '';
          this.endTime = '';
        });
      } else {
        this.isHalfShow = false;
        this.day = 0;
      }
    },
    parentRuleClick(item) {
      this.parentRuleShow = false;
      this.parentRule = item.id;
      this.parentRuleName = item.name;
      this.ruleRemark = item.remark;
      this.childRule = 0;
      this.day = 0;
      this.effectiveDate = '';
      this.getChildRuleList();
    },
    getChildRuleList: function () {
      this.$fetch("/attence-api/blade-holiday-rule/holidayrule/getChildRuleList", {
        parentId: this.parentRule
      }).then(
        res => {
          const data = res.data;
          this.childRuleName = '';
          this.childRuleList = [];
          let dayNum = 0;
          let childRule = null;
          data.forEach(v => {
            //如果配置的工作年限要求大于0并且当前登录人员的工作年限大于等于配置的工作年限
            if (parseInt(v.workYear) > 0 && parseInt(this.workYear) >= parseInt(v.workYear)) {
              if (parseInt(v.dayNum) > parseInt(dayNum)) {
                dayNum = v.dayNum;
                childRule = v;
              } else if (parseInt(v.workYear) == parseInt(childRule.workYear)) {//如果配置的工作年限都相同
                this.childRuleList.push(v);
              }
            } else if (parseInt(v.workYear) == -1) {
              this.childRuleList.push(v);
            }
          });
          if (childRule != null) {
            this.childRuleList.push(childRule);
          }
          if (this.childRuleList.length > 0) {
            this.childRuleList.forEach(v => {
              if (this.childRule == 0) {
                this.childRule = this.childRuleList[0].id;
                this.childRuleName = this.childRuleList[0].name;
                this.dayNum = this.childRuleList[0].dayNum;
                this.isTraffic = this.childRuleList[0].isTraffic;
                this.effectiveDays = this.childRuleList[0].effectiveDays;
                this.onceDays = this.childRuleList[0].onceDays;
                this.minDays = this.childRuleList[0].minDays;
                this.ruleRemark = this.childRuleList[0].remark;
                this.isOutYear = this.childRuleList[0].isOutYear;
                this.isUploadFile = this.childRuleList[0].isUploadFile;
                this.beginTime = '';
                this.endTime = '';
                this.isHalfShow = false;
              } else {
                if (this.childRule == v.id) {
                  this.childRule = v.id;
                  this.childRuleName = v.name;
                  this.dayNum = v.dayNum;
                  this.isTraffic = v.isTraffic;
                  this.effectiveDays = v.effectiveDays;
                  this.onceDays = v.onceDays;
                  this.minDays = v.minDays;
                  this.ruleRemark = v.remark;
                  this.isOutYear = v.isOutYear;
                  this.isUploadFile = v.isUploadFile;
                  const _this = this;
                  if (this.day <= 1) {
                    this.$fetch("/attence-api/blade-system/dict-biz/dictionary-tree", {
                      code: 'halfday'
                    }).then(res => {
                      const idcData = res.data;
                      if (_this.onceDays == 0.5) {
                        idcData.forEach(function (column) {
                          if (column.dictKey != 0) {
                            _this.dayHalfList.push(column);
                          }
                        });
                      } else {
                        idcData.forEach(function (column) {
                          _this.dayHalfList.push(column);
                        });
                      }
                    });
                  }
                }
              }
            });
            if(this.minDays != undefined && this.minDays > 1){//自动计算结束时间，不让选取结束时间
              this.showCalendarStatus = false;
            }
            this.getMyLeaveDaysAndShow();
            console.log("返回的数据：" + JSON.stringify(this.childRuleList));
          } else {
            this.leaveTotalDays = 0;
            this.surplusDays = 0;
            this.dayNum = 0;
            this.effectiveDays = -1;
            this.isTraffic = 0;
            if (this.workYear == 0) {
              Toast('工作年限小于1年，当前请假类型无法请假！');
            } else {
              Toast('工作年限为' + this.workYear + '年，当前请假类型无法请假！');
            }
          }
        });
    },
    childRuleClick(item) {
      this.childRule = item.id;
      this.childRuleName = item.name;
      this.childRuleShow = false;
      this.dayNum = item.dayNum;
      this.isTraffic = item.isTraffic;
      this.effectiveDays = item.effectiveDays;
      this.onceDays = item.onceDays;
      this.minDays = item.minDays;
      this.ruleRemark = item.remark;
      this.isOutYear = item.isOutYear;
      this.isUploadFile = item.isUploadFile;
      this.beginTime = '';
      this.endTime = '';
      this.isHalfShow = false;
      this.day = 0;
      this.effectiveDate = '';
      if(this.minDays != undefined && this.minDays > 1){//自动计算结束时间，不让选取结束时间
        this.showCalendarStatus = false;
      }
      this.getMyLeaveDaysAndShow();
    },
    onBeginConfirm(date) {
      this.showCalendarStatus = true;
      this.beginTime = moment(date).format("YYYY-MM-DD");
      this.endTime = '';
      if(this.minDays != undefined && this.minDays > 1){
        this.showCalendarStatus = false;
        this.beginLeaveDateChange();
      }
      this.showBeginCalendar = false;
    },
    onEndConfirm(date) {
      if (this.beginTime == '') {
        Toast('请先选择开始时间');
      } else {
        if (date.getTime() >= Date.parse(this.beginTime.replace(/\-/g, '/') + ' 00:00:00')) {
          this.endTime = moment(date).format("YYYY-MM-DD");
          this.leaveDateChange();
        } else {
          this.endTime = '';
          Toast('结束时间必须大于等于开始时间');
        }
      }

      this.showEndCalendar = false;
    },
    onEffectiveDateConfirm(date) {
      this.effectiveDate = moment(date).format("YYYY-MM-DD");
      this.beginTime = '';
      this.endTime = '';
      this.showEffectiveCalendar = false;
    },
    initHolidayRule() {
      const params = {
        processDefinitionId: this.processDefinitionId,
        appNo: this.appNo,
        processInstanceId: this.processInstanceId,
      };
      this.$fetch("/attence-api/blade-holiday-leave/holidayleave/getHolidayLeave", params).then(resp => {
          const data = resp.data;
          if (data.id != undefined) {
            this.leaveId = data.id;
            this.parentRule = data.ruleId;
            this.childRule = data.ruleSubId;
            this.beginTime = data.beginTime;
            this.endTime = data.endTime;
            this.day = data.day;
            if (this.day <= 1) {
              this.isHalfShow = true;
              this.dayHalf = data.halfDay + "";
            }
            this.trafficDay = data.trafficDay;
            this.reason = data.reason;
            this.allFiles = data.allFiles;
            this.effectiveDate = data.effectiveDate;
            this.leaveTotalDays = data.leaveTotalDays;
            this.surplusDays = data.surplusDays;
            this.showFiles = data.allFiles.applyFiles;
            this.showFiles.forEach(v => {
              this.applyFileIds.push(v.id);
              v.url = replaceUrl(v.viewUrl);
            });
          }

          this.$fetch("/attence-api/blade-holiday-rule/holidayrule/getParentRuleList", {}).then(res => {
              const data = res.data;
              this.parentRuleList = data;
              this.parentRuleList.forEach(v => {
                if (this.parentRule == 0) {
                  this.parentRule = this.parentRuleList[0].id;
                  this.parentRuleName = this.parentRuleList[0].name;
                  this.ruleRemark = this.parentRuleList[0].remark;
                } else {
                  if (this.parentRule == v.id) {
                    this.parentRule = v.id;
                    this.parentRuleName = v.name;
                    this.ruleRemark = v.remark;
                  }
                }
              });

              this.$fetch("/attence-api/blade-holiday-rule/holidayrule/getChildRuleList", {
                parentId: this.parentRule
              }).then(res => {
                const data = res.data;
                this.childRuleList = [];
                let dayNum = 0;
                let childRule = null;
                data.forEach(v => {
                  //如果配置的工作年限要求大于0并且当前登录人员的工作年限大于等于配置的工作年限
                  if (parseInt(v.workYear) > 0 && parseInt(this.workYear) >= parseInt(v.workYear)) {
                    if (parseInt(v.dayNum) > parseInt(dayNum)) {
                      dayNum = v.dayNum;
                      childRule = v;
                    } else if (parseInt(v.workYear) == parseInt(childRule.workYear)) {//如果配置的工作年限都相同
                      this.childRuleList.push(v);
                    }
                  } else if (parseInt(v.workYear) == -1) {
                    this.childRuleList.push(v);
                  }
                });
                if (childRule != null) {
                  this.childRuleList.push(childRule);
                }

                if (this.childRuleList.length > 0) {
                  this.childRuleList.forEach(v => {
                    if (this.childRule == 0) {
                      this.childRule = this.childRuleList[0].id;
                      this.childRuleName = this.childRuleList[0].name;
                      this.ruleRemark = this.childRuleList[0].remark;
                      this.dayNum = this.childRuleList[0].dayNum;
                      this.isTraffic = this.childRuleList[0].isTraffic;
                      this.effectiveDays = this.childRuleList[0].effectiveDays;
                      this.onceDays = this.childRuleList[0].onceDays;
                      this.minDays = this.childRuleList[0].minDays;
                      this.isOutYear = this.childRuleList[0].isOutYear;
                      this.beginTime = '';
                      this.endTime = '';
                      this.isHalfShow = false;
                    } else {
                      if (this.childRule == v.id) {
                        this.childRule = v.id;
                        this.childRuleName = v.name;
                        this.ruleRemark = v.remark;
                        this.dayNum = v.dayNum;
                        this.isTraffic = v.isTraffic;
                        this.effectiveDays = v.effectiveDays;
                        this.onceDays = v.onceDays;
                        this.minDays = v.minDays;
                        this.isOutYear = v.isOutYear;
                        const _this = this;
                        if (this.day <= 1) {
                          this.$fetch("/attence-api/blade-system/dict-biz/dictionary-tree", {
                            code: 'halfday'
                          }).then(res => {
                            const idcData = res.data;
                            if (_this.onceDays == 0.5) {
                              idcData.forEach(function (column) {
                                if (column.dictKey != 0) {
                                  _this.dayHalfList.push(column);
                                }
                              });
                            } else {
                              idcData.forEach(function (column) {
                                _this.dayHalfList.push(column);
                              });
                            }
                          });
                        }
                      }
                    }
                  });
                  if(this.minDays != undefined && this.minDays > 1){//自动计算结束时间，不让选取结束时间
                    this.showCalendarStatus = false;
                  }
                  this.getMyLeaveDaysAndShow();
                } else {
                  this.leaveTotalDays = 0;
                  this.surplusDays = 0;
                  this.dayNum = 0;
                  this.effectiveDays = -1;
                  this.isTraffic = 0;
                  if (this.workYear == 0) {
                    Toast('工作年限小于1年，当前请假类型无法请假！');
                  } else {
                    Toast('工作年限为' + this.workYear + '年，当前请假类型无法请假！');
                  }
                }

              });
            });
        });
    },
    onClickLeft: function () {
      let path = '';
      if (this.pageType == 0) {
        path = '/attenceflow/FlowList';
      } else {
        path = '/attenceflow/leave/list';
      }
      this.$router.push({
        path: path,
        query: {}
      });
    },
    halfChange() {
      if (this.dayHalf == 0) {
        this.day = 1;
      } else {
        this.day = 0.5;
      }
    },
    // 返回布尔值
    beforeApplyFileRead(file) {
      return true;
    },
    afterApplyFileRead(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      // 此时可以自行将文件上传至服务器
      console.log(file);
      let formData = new FormData();
      formData.append('file', file.file);
      formData.append('bizColumn', 'applyFiles');
      this.$filePost("/attence-api/blade-manager/bizAttach/upload", formData).then(
        res => {
          const data = res.data;
          file.status = 'done';
          file.message = '上传成功';
          this.applyFileIds.push(data.id);
          this.allFiles.applyFiles.push(data);
          console.log("IDS：" + JSON.stringify(data));
        },
        error => {
          file.status = 'failed';
          file.message = '上传失败';
        }
      );
    },
    beforeApplyFileDelete(file, detail) {
      let index = JSON.stringify(detail.index);
      let delId = this.applyFileIds[index];
      let url = "/attence-api/blade-manager/bizAttach/remove";
      this.$post(url, {
        ids: delId,
      }).then(
        res => {
          const data = res.data;
          this.applyFileIds.splice(index, 1);
          Toast('刪除成功');
          console.log("IDS：" + this.applyFileIds);
        },
        error => {
        }
      );
      return true;
    },
    taskSave() {
      if (this.childRule == 0) {
        Toast('请选择请假类型');
        return;
      }

      if (this.beginTime == '' || this.endTime == '') {
        Toast('请选择请假时间');
        return;
      }

      //请假有效期
      if (this.effectiveDays > -1 && (this.effectiveDate == null || this.effectiveDate == '')) {
        let message = "请选择领证日期";
        if(this.effectiveDays == 21900){
          message="请选择父母出生日期";
        } else if(this.effectiveDays == 1095){
          message="请选择孩子出生日期";
        }
        Toast(message);
        return;
      }

      if (this.reason == '') {
        Toast('请填写请假原因');
        return;
      }

      if (this.isUploadFile == 1) {
        Toast('请上传附件');
        return;
      }

      const params = {
        id: this.leaveId,
        ruleId: this.parentRule,
        ruleSubId: this.childRule,
        beginTime: this.beginTime,
        endTime: this.endTime,
        day: this.day,
        effectiveDate: this.effectiveDate,
        halfDay: this.dayHalf,
        conDay: this.leaveTotalDays,
        trafficDay: this.trafficDay,
        dayNum: this.dayNum,
        reason: this.reason,
        processDefinitionId: this.processDefinitionId,
        appNo: this.appNo,
        processInstanceId: this.processInstanceId,
        taskId: this.taskId,
        allFiles: this.allFiles,
      };
      this.$bodyPost("/attence-api/blade-holiday-leave/holidayleave/submit", params).then(resp => {
        Toast("数据保存成功");
        this.$router.push({
          path: "/attenceflow/leave/list",
          query: {}
        });
      }, error => {

      });
    },
    taskSubmit() {
      if (this.childRule == 0) {
        Toast('请选择请假类型');
        return;
      }

      if (this.beginTime == '' || this.endTime == '') {
        Toast('请选择请假时间');
        return;
      }

      //请假有效期
      if (this.effectiveDays > -1 && (this.effectiveDate == null || this.effectiveDate == '')) {
        let message = "请选择领证日期";
        if(this.effectiveDays == 21900){
          message="请选择父母出生日期";
        } else if(this.effectiveDays == 1095){
          message="请选择孩子出生日期";
        }
        Toast(message);
        return;
      }
      if (this.reason == '') {
        Toast('请填写请假原因');
        return;
      }

      if (this.isUploadFile == 1 && this.allFiles.applyFiles.length == 0) {
        Toast('请上传附件');
        return;
      }

      if (this.userInfo.roleId.split(",").length > 1) {
        this.$fetch("/attence-api/blade-user/getUserFlowRoleList", {}).then(res => {
          const data = res.data;
          this.roleList = [];
          data.forEach((v) => {
            if (v.roleFlow != undefined && v.roleFlow != "") {
              const flowLit = v.roleFlow.split("|");
              flowLit.forEach((flow) => {
                if (this.modelKey == flow) {
                  this.roleList.push(v);
                }
              });
            }
          });
          if (this.roleList.length > 1) {//流程发起角色大于1个选择角色发起流程
            this.choseRoleId = this.roleList[0].id;
            this.roleRadio = this.roleList[0].id;
            this.roleShow = true;
          } else {
            this.choseRoleId = this.roleList[0].id;
            //this.roleRadio = this.roleList[0].id;
            this.showProcessInfo();
          }
        });
      } else {
        this.choseRoleId = this.userInfo.roleId;
        this.showProcessInfo();
      }
    },
    roleCommit() {
      this.choseRoleId = this.roleRadio;
      this.showProcessInfo();
    },
    choseRoleSubmit() {
      const flowParams = {
        taskId: this.taskId,
        processInstanceId: this.processInstanceId,
        flag: 'ok',
        comment: this.reason,
        variables: {
          days: this.day
        },
      };

      const params = {
        id: this.leaveId,
        ruleId: this.parentRule,
        ruleSubId: this.childRule,
        beginTime: this.beginTime,
        endTime: this.endTime,
        day: this.day,
        effectiveDate: this.effectiveDate,
        halfDay: this.dayHalf,
        conDay: this.leaveTotalDays,
        trafficDay: this.trafficDay,
        dayNum: this.dayNum,
        reason: this.reason,
        processDefinitionId: this.processDefinitionId,
        appNo: this.appNo,
        processInstanceId: this.processInstanceId,
        allFiles: this.allFiles,
        flow: flowParams,
        choseRoleId: this.choseRoleId,
        surplusDays: this.surplusDays,
        leaveTotalDays:this.leaveTotalDays,
      };

      this.$bodyPost("/attence-api/blade-holiday-leave/holidayleave/leaveApply", params).then(resp => {
        const data = resp.data;
        Toast('流程提交成功');
        this.roleShow = false;
        this.processShow = true;
        this.jumpPage();
      });
    },
    jumpPage(){
      let path = '';
      if (this.pageType == 0) {
        path = '/attenceflow/FlowList';
      } else {
        path = '/attenceflow/leave/list';
      }
      this.$router.push({
        path: path,
        query: {}
      });
    },
    showProcessInfo() {
      //展示对话框
      this.$refs.showProcessDialog.showProcessInfo();
      this.roleShow = false;
    },
    submitFlowMethod() {
      this.choseRoleSubmit();
    },
    getFlowParamsMethod() {
      //用于对话框展示请求接口参数
      const params = {
        businessId: "",
        taskId: this.taskId,
        processInstanceId: this.processInstanceId,
        flag: 'ok',
        processDefinitionKey: this.modelKey,
        variables: {
          days: this.day,
          auditStatus: " ",
          choseRoleId: this.choseRoleId,
        },
      };

      return params;
    },
  }
}
</script>

<style scoped>
.van-nav-bar {
  background-color: #2196f3;
}

/deep/ .van-nav-bar__title {
  color: #fff;
}

/deep/ .van-nav-bar__text {
  color: #fff;
}

.login-form-top {
  margin-top: 0px;
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/attenceflow/leave/form.vue